import api, { unwrap } from './client';
import type { ApiResponse, PageResponse, SearchParams } from '@/types/api';
import type { BrandRequest, BrandResponse } from '@/types/product';

export const brandsApi = {
  list: (params?: SearchParams) =>
    unwrap(api.get<ApiResponse<PageResponse<BrandResponse>>>('/v1/brands', { params })),

  get: (id: number) => unwrap(api.get<ApiResponse<BrandResponse>>(`/v1/brands/${id}`)),

  create: (body: BrandRequest) =>
    unwrap(api.post<ApiResponse<BrandResponse>>('/v1/brands', body)),

  update: (id: number, body: BrandRequest) =>
    unwrap(api.put<ApiResponse<BrandResponse>>(`/v1/brands/${id}`, body)),

  delete: (id: number) => unwrap(api.delete<ApiResponse<null>>(`/v1/brands/${id}`)),

  activate: (id: number, active: boolean) =>
    unwrap(
      api.patch<ApiResponse<BrandResponse>>(`/v1/brands/${id}/activate`, null, {
        params: { active },
      }),
    ),
};
